<ng-container *adaptLoading="!initialised">
    @if (categoryScoreSummary || categoryIntro) {
        <div class="survey-category-summary">
            <span class="survey-category-text">
                @if (categoryScoreSummary) {
                    <h3>Result summary</h3>
                    {{ categoryScoreSummary }}
                } @else {
                    <div [froalaView]="categoryIntro"></div>
                }
            </span>
            <adapt-display-category-percentage [text]="doughnutText"
                                               [percentage]="percentageScore"
                                               [surveyType]="latestSurvey?.surveyType"></adapt-display-category-percentage>
        </div>
    }
    <div class="d-flex flex-row">
        <h3 class="question-column">Questions</h3>
        @if (isXL && latestSurvey && responseGroups.length > 1) {
            <div class="question-stats d-flex">
                @for (group of responseGroups; track group) {
                    <h4 class="w-50 text-center">
                        {{ responseGroupLabel[group] }}
                    </h4>
                }
            </div>
        }
    </div>
    @for (questionId of categoryQuestionIds; track questionId) {
        <div class="survey-category-question d-flex flex-column flex-xl-row align-items-center avoid-page-break-inside">
            <span class="question-column">{{ questionId }}. {{ surveyQuestions.getQuestion(questionId) }}</span>
            <adapt-display-survey-question-stats class="question-stats"
                                                 [showQuestionResponseDistribution]="false"
                                                 [survey]="survey"
                                                 [surveyQuestions]="surveyQuestions"
                                                 [forceInitialise]="forceInitialise"
                                                 [questionId]="questionId"></adapt-display-survey-question-stats>
        </div>
    }
</ng-container>
